// Shared helpers for the lawyer Availability page — 30-min cells ⇄ merged windows, IST labels.
export const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const DAY_LABEL = { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun" };
export const GRID_START = 7 * 60;   // 07:00 IST
export const GRID_END = 22 * 60;    // 22:00 IST
export const CELL = 30;
export const CELLS = Array.from({ length: (GRID_END - GRID_START) / CELL }, (_, i) => GRID_START + i * CELL);
export const DEFAULT_WEEKLY = Object.fromEntries(DAYS.map((d) => [d, []]));  // "Reset to default" = clear every day

export const toMin = (hm) => { const [h, m] = hm.split(":").map(Number); return h * 60 + m; };
export const toHM = (min) => `${String(Math.floor(min / 60)).padStart(2, "0")}:${String(min % 60).padStart(2, "0")}`;
export const fmt12 = (hm) => { const m = toMin(hm); const h = Math.floor(m / 60); const ap = h >= 12 ? "pm" : "am"; return `${((h + 11) % 12) + 1}${m % 60 ? ":30" : ""}${ap}`; };

// windows → Set of cell-start minutes (only cells inside the visible grid)
export const windowsToCells = (windows = []) => {
  const set = new Set();
  windows.forEach(([a, b]) => { for (let t = toMin(a); t < toMin(b); t += CELL) if (t >= GRID_START && t < GRID_END) set.add(t); });
  return set;
};

// Set of cells → merged consecutive windows
export const cellsToWindows = (set) => {
  const sorted = [...set].sort((a, b) => a - b);
  const out = [];
  sorted.forEach((t) => {
    const last = out[out.length - 1];
    if (last && toMin(last[1]) === t) last[1] = toHM(t + CELL);
    else out.push([toHM(t), toHM(t + CELL)]);
  });
  return out;
};

export const windowsLabel = (windows = []) => (windows.length ? windows.map(([a, b]) => `${fmt12(a)}–${fmt12(b)}`).join(", ") : "Day off");
export const sameWeekly = (a, b) => DAYS.every((d) => JSON.stringify(a[d] || []) === JSON.stringify(b[d] || []));
export const istToday = () => new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
export const isoDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const weekdayKey = (iso) => DAYS[(new Date(`${iso}T00:00:00`).getDay() + 6) % 7];
